<template>
  <div>
    <Table
      resource="Brand"
      :actions="actions"
      :items="$store.getters['brand/tableData']"
      :detail="$store.getters['brand/detailData']"
      :fields="$store.getters['brand/tableFields']"
      :pagination="$store.state.brand.tablePagination"
      :keyword="$store.state.brand.tableKeyword"
      :loading="$store.state.brand.loadingTable"
      :filter="$store.state.brand.tableFilter"
      :sort="$store.state.brand.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('brand/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('brand/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('brand/delete', id)
        .then(callback)
    },
    resetDetail() {
      this.$store.commit('brand/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('brand/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('brand/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('brand/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('brand/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('brand/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('brand/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
